// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ArtistLink_imageWrapper__LzVsZ","content":"ArtistLink_content__3-3sE","artistLink":"ArtistLink_artistLink__Xr4F1","artistLinkText":"ArtistLink_artistLinkText__hpaoa"};